import {useMutation, useQueryClient} from 'react-query'
import {Location} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: Location) => {
    showNotification({
        title: 'Location updated',
        icon: <Check/>,
        message: `Location '${values.name}' has been updated!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the location. ${error}`,
        color: 'red'
    })
}

export default function useMutateLocationData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload location data
            queryClient.invalidateQueries(['locations']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
